export const APP_START = 'boilerplate/app_start';
export const APP_ERROR = 'APP_ERROR';
export const CHANGE_LOCALE = 'change_locale';
export const APP_INITIALIZATION_END = 'APP_INITIALIZATION_END';
export const LOAD_TRANSLATIONS = 'LOAD_TRANSLATIONS';
export const APP_MESSAGE_UPDATE = 'APP_MESSAGE_UPDATE';
// MS Graph api call fail
export const MS_REST_API_CALL_FAIL = 'MS_REST_API_CALL_FAIL';
export const APP_RESET = 'APP_RESET';